import Subject from "../cse4sub/Subject";
import React from 'react'

export default function Cd() {
  return (
    <div>
       <Subject title="Compiler Design(CSE601)" sub="Compiler Design" syllabus="#"
    book1="Alfred V. Aho, Ravi Sethi, Monica S. Lam and J.D. Ullman, “Compilers: Principles, Techniques and 
    Tools”,(2nd Ed.),Pearson Education" book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=54575584&h=e122e8b75d5def9cd93a6f0f2ab1c70f&u=cache&ext=pdf
    "
     book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}